import * as deliveryZoneCoordinators from './deliveryZones'
import * as headquarterCoordinators from './headquarters'
import * as serviceDepotCoordinators from './serviceDepots'

export default Object.freeze({
  ...deliveryZoneCoordinators,
  ...headquarterCoordinators,
  ...serviceDepotCoordinators,
})
